module.exports = __webpack_public_path__ + "img/excel.e8836920.png";